export enum ProviderContactCardDataSources {
  NppesProviders = "nppes_providers",
  NppesPracticeLocations = "nppes_practice_locations",
  LexisNexis = "lexis_nexis",
  UserDefined = "user_defined",
}

export type ProviderContactCardDataSourceTypes = "nppes_providers" | "nppes_practice_locations" | "lexis_nexis" | "user_defined";
